import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "align-items-center flex justify-content-between w-full" }
const _hoisted_2 = { class: "align-items-center bg-light-gray border-round-sm flex justify-content-center p-2" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { class: "w-full p-input-icon-left" }
const _hoisted_5 = { class: "p-datatable p-component p-datatable-scrollable p-datatable-responsive-scroll mt-3" }
const _hoisted_6 = { class: "p-datatable-wrapper" }
const _hoisted_7 = {
  role: "table",
  class: "p-datatable-table text-sm"
}
const _hoisted_8 = {
  class: "p-datatable-tbody block",
  role: "rowgroup"
}
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["textContent"]
const _hoisted_16 = ["textContent"]
const _hoisted_17 = ["textContent"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 1 }

import { computed, onMounted, ref, toRefs, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useEvaluationStore, useOrganizationStore } from '@/store';
import { can, usePersonTypes } from '@/composables';
import AutoComplete from 'primevue/autocomplete';
import ScrollPanel from 'primevue/scrollpanel';
import DisciplineIcon from '@/components/DisciplineIcon/DisciplineIcon.vue';
import { PERMISSIONS } from '@/enum';

interface EvaluationPropsInterface {
  organizationsIds?: number[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Evaluation',
  props: {
    organizationsIds: {}
  },
  emits: ['scheduleEvent', 'reload'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const { organizationsIds } = toRefs(props);

const evaluationStore = useEvaluationStore();
const organizationStore = useOrganizationStore();

const { completed, overdueStudents, upcomingStudents, loading, selectedStudentId, students } =
  storeToRefs(evaluationStore);

const organizationsIdsSelected = computed(() => organizationStore.organizationsIdsSelected);

const emit = __emit;

const selectedStudent = ref();

const filteredStudents = ref(students.value);

onMounted(() => init());

watch(selectedStudent, () => {
  if (selectedStudent.value?.id) {
    selectedStudentId.value = selectedStudent.value.id;
    return;
  }

  if (!selectedStudent.value?.id) {
    selectedStudentId.value = 0;
  }
});

const openScheduleEvent = async (studentId: number, dueAt: string) => {
  const [year, month, day] = dueAt.split('-').map((part) => Number(part));
  const dueDate = new Date(year, month - 1, day);
  emit('scheduleEvent', studentId, dueDate);
};

const init = async () => {
  const organizationIdToSee = !can([PERMISSIONS.WIDGET_EVALUATION_ALL]) ? organizationsIds?.value : [];
  const organizationsIdToEvaluate: number[] | undefined =
    organizationsIdsSelected.value.length == 0 ? organizationIdToSee : organizationsIdsSelected.value;

  await evaluationStore.getEvaluations(organizationsIdToEvaluate || []);
};

const searchStudent = (event) => {
  if (event.query.trim().length < 1) {
    return;
  }

  filteredStudents.value = students.value.filter((student) => {
    return student.full_name.toLowerCase().search(event.query.toLowerCase()) >= 0;
  });
};

const canScheduleEvaluations = computed(() => usePersonTypes.isClinician());

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "page-content-full" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex" }, [
          _createElementVNode("span", {
            class: "material-icons mr-2",
            style: {"color":"#078888"}
          }, "assignment_turned_in"),
          _createElementVNode("h2", null, "Evaluations")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-dark text-xs mr-1" }, "Completed", -1)),
          (!_unref(loading))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "text-sm text-primary-dark font-bold",
                textContent: _toDisplayString(_unref(completed))
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createBlock(_component_Skeleton, {
                key: 1,
                shape: "rectangle",
                size: "10px"
              }))
        ])
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_IconField, { "icon-position": "left" }, {
          default: _withCtx(() => [
            _createVNode(_component_InputIcon, {
              class: "p-input-icon-left",
              style: {"z-index":"100"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  name: "search",
                  class: "text-lg"
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(AutoComplete), {
              modelValue: selectedStudent.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedStudent).value = $event)),
              "force-selection": "",
              class: "autocomplete w-full",
              "input-class": "w-full pl-5",
              suggestions: filteredStudents.value,
              placeholder: "Search Students",
              "min-length": 2,
              field: "full_name",
              "data-key": "id",
              onComplete: _cache[1] || (_cache[1] = ($event: any) => (searchStudent($event)))
            }, null, 8, ["modelValue", "suggestions"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _cache[10] || (_cache[10] = _createElementVNode("thead", {
              class: "p-datatable-thead",
              role: "rowgroup"
            }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("div", { class: "p-column-header-content" }, [
                    _createElementVNode("span", { class: "p-column-title" }, "Student")
                  ])
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("div", { class: "p-column-header-content" }, [
                    _createElementVNode("span", { class: "p-column-title" }, "Due Date")
                  ])
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("div", { class: "p-column-header-content" }, [
                    _createElementVNode("span", { class: "p-column-title" }, "Scheduled")
                  ])
                ])
              ])
            ], -1)),
            (!_unref(loading))
              ? (_openBlock(), _createBlock(_unref(ScrollPanel), {
                  key: 0,
                  style: {"width":"100%","height":"400px"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("tbody", _hoisted_8, [
                      _cache[8] || (_cache[8] = _createElementVNode("tr", null, [
                        _createElementVNode("td", {
                          class: "p-1 pl-3 bg-extra-light text-dark-red border-none",
                          colspan: "3"
                        }, "Overdue")
                      ], -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(overdueStudents), (data) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: `${data.person.id}${data.due_at}${data.discipline.id}`
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("p", {
                              textContent: _toDisplayString(data.person.full_name)
                            }, null, 8, _hoisted_9),
                            _createVNode(DisciplineIcon, {
                              classes: "mx-2",
                              code: data.discipline.code
                            }, null, 8, ["code"])
                          ]),
                          _createElementVNode("td", {
                            class: "font-semibold text-dark-red",
                            textContent: _toDisplayString(data.due_at_formatted)
                          }, null, 8, _hoisted_10),
                          (data.scheduled_date)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 0,
                                textContent: _toDisplayString(data.scheduled_date)
                              }, null, 8, _hoisted_11))
                            : (_openBlock(), _createElementBlock("td", _hoisted_12, [
                                (canScheduleEvaluations.value)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "flex align-items-center text-primary-dark font-semibold cursor-pointer",
                                      onClick: ($event: any) => (openScheduleEvent(data.person.id, data.due_at))
                                    }, [
                                      _createVNode(_component_Icon, {
                                        name: "add",
                                        class: "text-primary-medium"
                                      }),
                                      _cache[4] || (_cache[4] = _createTextVNode(" Schedule Evaluation ", -1))
                                    ], 8, _hoisted_13))
                                  : _createCommentVNode("", true)
                              ]))
                        ]))
                      }), 128)),
                      (_unref(overdueStudents).length <= 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("td", { colspan: "3" }, "No evaluations overdue.", -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      _cache[9] || (_cache[9] = _createElementVNode("tr", null, [
                        _createElementVNode("td", {
                          class: "p-1 pl-3 bg-extra-light text-dark-medium border-none",
                          colspan: "3"
                        }, "Upcoming")
                      ], -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(upcomingStudents), (data, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("p", {
                              textContent: _toDisplayString(data.person.full_name)
                            }, null, 8, _hoisted_15),
                            _createVNode(DisciplineIcon, {
                              classes: "mx-2",
                              code: data.discipline.code
                            }, null, 8, ["code"])
                          ]),
                          _createElementVNode("td", {
                            textContent: _toDisplayString(data.due_at_formatted)
                          }, null, 8, _hoisted_16),
                          (data.scheduled_date)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 0,
                                textContent: _toDisplayString(data.scheduled_date)
                              }, null, 8, _hoisted_17))
                            : (_openBlock(), _createElementBlock("td", _hoisted_18, [
                                (canScheduleEvaluations.value)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "flex align-items-center text-primary-dark font-semibold cursor-pointer",
                                      onClick: ($event: any) => (openScheduleEvent(data.person.id, data.due_at))
                                    }, [
                                      _createVNode(_component_Icon, {
                                        name: "add",
                                        class: "text-primary-medium"
                                      }),
                                      _cache[6] || (_cache[6] = _createTextVNode(" Schedule Evaluation ", -1))
                                    ], 8, _hoisted_19))
                                  : _createCommentVNode("", true)
                              ]))
                        ]))
                      }), 128)),
                      (_unref(upcomingStudents).length <= 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("td", { colspan: "3" }, "No evaluations upcoming.", -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(new Array(8), (i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                    _createVNode(_component_Skeleton, {
                      class: "my-1",
                      height: "53px"
                    })
                  ]))
                }), 128))
          ])
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "p-column-resizer-helper hidden" }, null, -1))
      ])
    ]),
    _: 1
  }))
}
}

})